const rndId =(len = 30) => {
    var p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    return [...Array(len)].reduce(a=>a+p[~~(Math.random()*p.length)],'');
}

const callIfNotVisible = (callback) => {
    if (document.visibilityState !== "hidden") {
        return;
    }

    return callback()
}

export {rndId, callIfNotVisible};